import { render, staticRenderFns } from "./EmailViewItem.vue?vue&type=template&id=4ee93afa&scoped=true"
import script from "./EmailViewItem.vue?vue&type=script&lang=js"
export * from "./EmailViewItem.vue?vue&type=script&lang=js"
import style0 from "./EmailViewItem.vue?vue&type=style&index=0&id=4ee93afa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee93afa",
  null
  
)

export default component.exports